const UNITS: [number, string][] = [
  [24 * 60 * 60, 'day'],
  [60 * 60, 'hour'],
  [60, 'minute'],
  [1, 'second'],
];

/**
 * Format a number of seconds using the largest unit that divides it exactly,
 * e.g. 3600 => "1 hour", 5400 => "90 minutes"
 */
export default function formatDuration(seconds: number): string {
  for (const [size, unit] of UNITS) {
    if (seconds >= size && seconds % size === 0) {
      const count = seconds / size;

      return `${count} ${unit}${count === 1 ? '' : 's'}`;
    }
  }

  return `${seconds} seconds`;
}
